import { QUICK_SUPPORT_SUMMARY } from '../actionTypes';

const initialState = {
  content: [],
  sectionList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case QUICK_SUPPORT_SUMMARY.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case QUICK_SUPPORT_SUMMARY.SUCCESS_SECTION:
      return {
        ...state,
        sectionList: action.payload,
      };
    default:
      return state;
  }
};
